import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
// const options = {role: ROLE.SUPER_ADMIN};
const options = {};

const path = "admin/temple-booking"

export const TempleBookingList = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const AssignRunner = async (values) => {
    return await axiosInstance(options).post(`${path}/runner-assign`, values);
}

export const ListRunner = async (values) => {
  return axiosInstance(options).get(`${path}/runner-list`, {
    params: values,
  });
};

export const TempleBookingDetails = async (id) => {
    return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
}